var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-footer"},[_vm._v(" © "+_vm._s(_vm.$t("AddRightsReserved"))+". v"+_vm._s(_vm.$version)+"."),_c('span',{staticClass:"small"},[_vm._v(_vm._s(_vm.$store.getters.retailerId))]),_vm._v("  "),_c('router-link',{attrs:{"to":"/privacypolicy"}},[_vm._v(_vm._s(_vm.$t("Privacy Policy")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }